import React from "react";
import {
  FaGraduationCap,
  FaPassport,
  FaUserGraduate,
  FaPlane,
  FaHotel,
  FaComments,
} from "react-icons/fa";
import { Container } from "@mui/material";

const ServiceCard = ({ icon: Icon, title, description }) => (
  <div className="bg-white border-x-2 p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
    <div className="flex flex-col items-center text-center">
      <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-4">
        <Icon className="w-8 h-8 text-blue-400" />
      </div>
      <h3 className="text-xl font-bold text-gray-900 mb-3">{title}</h3>
      <p className="text-gray-600">{description}</p>
    </div>
  </div>
);

const ServicesSection = () => {
  const services = [
    {
      icon: FaGraduationCap,
      title: "Admission Abroad",
      description:
        "Expert guidance for international university admissions, helping you choose the right program and institution for your academic journey.",
    },
    {
      icon: FaPassport,
      title: "Visit Visa",
      description:
        "Streamlined visa application process for tourist and business visits, ensuring smooth travel documentation.",
    },
    {
      icon: FaUserGraduate,
      title: "Student Visa",
      description:
        "Comprehensive support for student visa applications, including documentation preparation and application processing.",
    },
    {
      icon: FaPlane,
      title: "Flight Reservations",
      description:
        "Access to competitive airfares and flight bookings worldwide, with flexible scheduling options.",
    },
    {
      icon: FaHotel,
      title: "Hotel Reservations",
      description:
        "Curated selection of accommodation options worldwide, from luxury hotels to budget-friendly stays.",
    },
    {
      icon: FaComments,
      title: "Student Counseling",
      description:
        "Professional guidance for academic choices, career planning, and adjustment to international education.",
    },
  ];

  return (
    <Container>
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-8">
          <h2 className="text-4xl font-bold text-gray-900 ">Our Services</h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Comprehensive solutions for international education and travel
            needs, providing expert guidance every step of the way.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              icon={service.icon}
              title={service.title}
              description={service.description}
            />
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <button className="bg-primary text-white px-8 py-3 rounded-full shadow-xl hover:shadow-2xl hover:bg-blue-700 transition-colors inline-flex items-center gap-2">
            Explore Our Services
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>
      </div>
    </Container>
  );
};

export default ServicesSection;
